module.exports = __webpack_public_path__ + "static/img/pic_rjyf_cxnl_jscx.b2b50ba4.png";